var _a;
import { pxToRem } from '../utils/utils';
import { breakpoints } from './breakpoints';
export var grids = {
    gridColumns: 12,
    gridGap: pxToRem('20px'),
    columns: (_a = {
            all: {
                prefix: '',
                columns: ['1 3', '1 5', '1 8', '1 9', '1 10', '1 12', '6 12', '9 12', '10 12', '11 12'],
            }
        },
        _a[breakpoints.mobile] = {
            prefix: 'xs-',
            columns: ['1 3'],
            gutterWidth: pxToRem('16px'),
        },
        _a[breakpoints.tablet] = {
            prefix: 'sm-',
            columns: ['1 6', '1 8', '1 12', '2 7', '2 11', '3 10', '7 12', '9 12'],
            gutterWidth: pxToRem('16px'),
        },
        _a[breakpoints.laptop] = {
            prefix: 'md-',
            columns: [
                '1 3',
                '1 4',
                '1 6',
                '1 8',
                '1 9',
                '1 12',
                '2 8',
                '2 9',
                '2 11',
                '2 12',
                '3 10',
                '4 9',
                '4 12',
                '5 12',
                '9 12',
                '10 12',
            ],
            gutterWidth: pxToRem('24px'),
        },
        _a[breakpoints.desktop] = {
            prefix: 'xl-',
            columns: ['2 7', '4 9'],
            gutterWidth: pxToRem('40px'),
        },
        _a),
};
